
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconDragDrop = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z', 'data-name': 'Invisible Shape' }),
    React.createElement('circle', { cx: '9.18', cy: '3.7', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '3.7', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '9.2', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '9.2', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '14.8', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '14.8', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '20.4', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '20.4', r: '1.2' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z', 'data-name': 'Invisible Shape' }),
    React.createElement('circle', { cx: '9.18', cy: '3.7', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '3.7', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '9.2', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '9.2', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '14.8', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '14.8', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '20.4', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '20.4', r: '1.2' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { fill: 'none', d: 'M0 0h24v24H0z', 'data-name': 'Invisible Shape' }),
    React.createElement('circle', { cx: '9.18', cy: '3.7', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '3.7', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '9.2', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '9.2', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '14.8', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '14.8', r: '1.2' }),
    React.createElement('circle', { cx: '9.18', cy: '20.4', r: '1.2' }),
    React.createElement('circle', { cx: '14.78', cy: '20.4', r: '1.2' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconDragDrop.displayName = 'IconDragDrop';
export default IconDragDrop;